import React from 'react';
import styles from './About.module.css';

const About = () => {
  return (
    <div className={styles['about-container']}>
      <div className={styles['hero-section']}>
        <div className={styles['hero-content']}>
          <h1 className={styles.title}>About <span>HackerBlog</span></h1>
          <p className={styles.subtitle}>Empowering the tech community with knowledge, insights, and resources.</p>
        </div>
      </div>
      
      <div className={styles['content-section']}>
        <div className={styles.card}>
          <p>
            HackerBlog is the premier online destination for those interested in technology, coding, security, and more. We provide the latest news and updates, tutorials, reviews, and guides for anyone looking to stay ahead of the curve on the latest trends and developments in the tech world.
          </p>
          <p>
            Our team of experienced writers and engineers strive to bring you the best information and resources possible, so you can stay informed and competitive.
          </p>
          <p>
            Whether you're a novice or an expert, HackerBlog has something for everyone. From tutorials for beginners to in-depth analysis of the latest trends in tech, we have you covered. We also have a comprehensive library of resources, including links to helpful websites, tools, and articles.
          </p>
          <p>
            HackerBlog is also home to a vibrant community of users who share their knowledge and experiences. Join us today to become part of the conversation and get the help and support you need to succeed. Thanks for visiting HackerBlog! We hope you find the content and resources you need to stay ahead of the game.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
